'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = require('react-intl');

var refusesToSignOverride = (0, _reactIntl.defineMessages)({
    PAX_REFUSES_TO_SIGN_LEGAL_APPROVED: {
        'id': 'formOverrides.participationWaiver.PAX_REFUSES_TO_SIGN_LEGAL_APPROVED',
        'defaultMessage': 'Pax refuses to sign, has been approved by Legal'
    }
});

var waiver = {
    PARTICIPATION_WAIVER: refusesToSignOverride,
    LIABILITY_WAIVER: refusesToSignOverride,
    LIABILITY_WAIVER_KAYAKING: refusesToSignOverride,
    LIABILITY_WAIVER_CAMPING: refusesToSignOverride
};

exports.default = waiver;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOverrides/waiver.js
// module id = 1389
// module chunks = 0